export default __webpack_public_path__ + "static/contact-hero-3-5b319ebc5825d4cd604e7b41d33f1f3b.png";